class Input
    constructor: (el) ->
        @.$el = el
        @.$deleteBtn = @.$el.querySelector '.input__delete'
        @.$input = @.$el.querySelector '.input__field'
        @.$quantityNav = undefined
        @.$quantityUp = undefined
        @.$quantityDown = undefined

        # check if element with class input is Input component
        if @.$input
            @.isNumberType = if @.$input?.type then @.$input.type == "number" else false
            @.max = undefined
            @.min = undefined
            @.noDelete = @.$el.classList.contains 'input--no-delete'
            @.required = if @.$input?.required then @.$input.required else false
            @.step = undefined

            if @.isNumberType
                @.CreateQuantityNav()
            @.InitEvents()
            if !@.noDelete
                @.CheckDeleteButtonState()
            @.$el.classList.add 'input--bound'
        else
            @.$el.classList.add 'input--bound-nv'
        return

    CheckDeleteButtonState: ->
        if !@.noDelete
            if @.$input.value && @.$input.value != ""
                @.$el.classList.add 'input--value'
            else
                @.$el.classList.remove 'input--value'
        return

    CreateQuantityNav: ->
        @.max = @.$input.max ? undefined
        @.min = @.$input.min ? undefined
        @.step = @.$input.step || 1
        @.$quantityNav = document.createElement 'div'
        @.$quantityNav.classList.add 'input__quantity-nav'
        @.$quantityNav.innerHTML = '
            <button class="input__quantity-up" type="button">+</button>
            <button class="input__quantity-down" type="button">-</button>
        '
        @.$el.appendChild @.$quantityNav
        @.$quantityUp = @.$quantityNav.querySelector '.input__quantity-up'
        @.$quantityDown = @.$quantityNav.querySelector '.input__quantity-down'
        return

    DeleteInput: ->
        @.$input.value = ""
        @.CheckDeleteButtonState()
        return
    
    HandleQuantity: (direction) ->
        actualValue = @.$input.value
        actualValue = if actualValue != "" then parseFloat(actualValue) else 0
        step = @.step * (if direction == 'down' then -1 else 1)
        value = actualValue + step
        if direction == 'up'
            if @.max
                if value >= @.max
                    value = @.max
        else
            if @.min
                if value <= @.min
                    value = @.min
        @.SetNumberValue value
        return
    
    InitEvents: ->
        self = @
        if !@.noDelete && !@.isNumberType && @.$deleteBtn
            @.$deleteBtn.addEventListener 'click', (e) ->
                self.DeleteInput()
                return
        @.$input.addEventListener 'input', (e) ->
            if !self.noDelete && !self.isNumberType && self.$deleteBtn
                self.CheckDeleteButtonState()
            self.SetErrorState if self.required then @.value == "" else false
            return
        @.$el.addEventListener 'input-set-value', (e) ->
            value = e.detail?.value ? false
            triggerEvents = e.detail?.triggerEvents ? true
            if value
                self.SetValue value, triggerEvents
            return
        @.$el.addEventListener 'input-set-error', (e) ->
            error = e.detail?.error ? false
            self.SetErrorState error
            return
        @.$el.addEventListener 'input-delete', (e) ->
            e.preventDefault()
            e.stopPropagation()
            self.DeleteInput()
            return
        if @.isNumberType
            @.$quantityUp.addEventListener 'click', (e) ->
                e.preventDefault()
                e.stopPropagation()
                self.HandleQuantity 'up'
                return
            @.$quantityDown.addEventListener 'click', (e) ->
                e.preventDefault()
                e.stopPropagation()
                self.HandleQuantity 'down'
                return
        return
    
    SetErrorState: (state) ->
        if state
            @.$el.classList.add 'input--error'
        else
            @.$el.classList.remove 'input--error'
        return
    
    SetNumberValue: (value, triggerEvents) ->
        triggerEvents = if typeof triggerEvents == "undefined" || typeof triggerEvents == 'null' then true else triggerEvents
        if isNaN(value)
            value = parseFloat(value)
        @.$input.value = value
        if triggerEvents
            @.$input.dispatchEvent new Event 'change', { bubbles: true }
            @.$input.dispatchEvent new Event 'input', { bubbles: true }
        return
    
    SetValue: (value, triggerEvents) ->
        if @.isNumberType
            @.SetNumberValue value, triggerEvents
        else
            @.$input.value = value
            @.CheckDeleteButtonState()
        return

BindInputs = ->
    document.querySelectorAll '.input:not(.input--bound):not(.input--bound-nv)'
        .forEach (el) ->
            new Input el
            return
    return

window.addEventListener 'bind-components', BindInputs

class InputCreate
    constructor: (options) ->
        @.$el = null

        @.options = options ? {}

        @.CreateElement()
        if !@.options?.bindLater
            new Input @.$el
        return @.$el

    CreateElement: ->
        @.$el = document.createElement (@.options.tag ? 'div')
        @.$el.classList.add 'input'
        if @.options.color
            @.$el.classList.add "input--#{ @.options.color }"
        if @.options.error
            @.$el.classList.add 'input--error'
        if @.options.noDelete
            @.$el.classList.add 'input--no-delete'
        if @.options.outline
            @.$el.classList.add 'input--outline'
        if @.options.id
            @.$el.id = @.options.id
        if @.options.attrs
            @.$el = window.appUtils.Attributes @.options.attrs, @.$el
        inputEl = document.createElement 'input'
        inputEl.classList.add 'input__field'
        if @.options.autocomplete
            inputEl.setAttribute 'autocomplete'
        if @.options.disabled
            inputEl.setAttribute 'disabled'
        if @.options.inputId
            inputEl.id = @.options.inputId
        if @.options.inputmode
            inputEl.setAttribute 'inputmode', @.options.inputmode
        if @.options.max
            inputEl.setAttribute 'max', @.options.max
        if @.options.maxlength
            inputEl.setAttribute 'maxlength', @.options.maxlength
        if @.options.min
            inputEl.setAttribute 'min', @.options.min
        if @.options.name
            inputEl.setAttribute 'name', @.options.name
        if @.options.pattern
            inputEl.setAttribute 'pattern', @.options.pattern
        if @.options.placeholder
            inputEl.setAttribute 'placeholder', @.options.placeholder
        if @.options.readonly
            inputEl.setAttribute 'readonly'
        if @.options.step
            inputEl.setAttribute 'step', @.options.step
        inputEl.type = @.options.type ? 'text'
        value = @.options.value ? false
        if value
            inputEl.setAttribute 'value', value
        if @.options.inputAttrs
            inputEl = window.appUtils.Attributes @.options.inputAttrs, inputEl
        @.$el.appendChild inputEl
        @.$el.innerHTML += "
            <button type='button' class='input__delete'></button>
        "
        return

window.CreateInput = (options) ->
    return new InputCreate options